import React, { useRef } from 'react'
import { useParams } from 'react-router-dom'
import styled from '@emotion/styled'
import { Button } from '@ow/comps'
import { allRolesSWR } from '@vt/apis/lib-ex/v2/role'
import AddRole from './components/OperationRole'
import RoleTable from './components/RoleTable'

const borderColor = '#dbdfea'
const Container = styled.div`
  flex: 1 1 0%;
  padding: 18px;
`

const RolesContent = styled.div`
  border: 1px solid ${borderColor};
  background-color: #fff;
  border-radius: 4px;
`

const Role = function () {
  const { appId } = useParams()
  const popupRef = useRef(null)
  const { allRoles, allRolesMutate } = allRolesSWR(appId)

  return (
    <>
      <Container className="w-full h-full">
        <RolesContent className="h-full w-full flex flex-col items-center">
          <div className="w-full flex items-center justify-end p-2">
            <Button
              onClick={() => {
                if (popupRef.current) {
                  popupRef.current.open()
                }
              }}
              type="primary"
            >
              添加角色
            </Button>
          </div>
          <RoleTable
            appId={appId}
            roles={allRoles}
            rolesMutate={allRolesMutate}
          />
        </RolesContent>
      </Container>

      <AddRole
        appId={appId}
        rolesMutate={allRolesMutate}
        closeModal={() => {
          if (popupRef.current) {
            popupRef.current.close()
          }
        }}
        ref={popupRef}
      />
    </>
  )
}
export default Role
